


import React, { Component } from 'react'
import { Button, Label, Image } from 'semantic-ui-react'
import { convertEpochToDate, mapActivityName, checkMarkEvents } from '../../../util/constants';
import Images from '../../../config/images';

export class ActivityCard extends Component {

  getIcon = (numberLeft, tagImage, color) => {
    if (numberLeft === 'container') return <i className="leftImg"><Image circular src={Images.carrierTruck} alt="tag"
      className={`leftIcon ${color} container`} /></i>
    if (checkMarkEvents[numberLeft]) {
      if (color === 'GRAY_MILESTONE') {
        return <i className={`leftIcon ${color}`}>-</i>
      }
      if (color === 'ORANGE_MILESTONE') {
        return <i className={`leftIcon ${color}`}>-</i>
      }
      if (numberLeft === 'Containers Unloaded and Ready for Pickup') return <i className="leftImg"><Image circular
        src={Images.containerPickup}
        alt="tag"
        className={`leftIcon ${color} container`} /></i>
      return <i className="leftImg"><img src={tagImage} alt="tag" className="img" /></i>
    }
    if (numberLeft === 'Vessel departed from port of lading' || numberLeft === 'Vessel arrived at port of unlading') {
      return <div className={`activity-port`} style={{ position: 'absolute' }} />
    }
    if (numberLeft) {
      return <i className={`leftIcon ${color}`}> {numberLeft} </i>;
    } else if (tagImage === 'document') {
      return <div style={{ display: 'none' }}></div>;
    } else if (tagImage) {
      return <i className="leftImg"><img src={tagImage} alt="tag" className="img" /></i>;
    } else {
      return <div className={`activity-port`} style={{ position: 'absolute' }} />
    }
  }

  render() {
    const {
      statusContent,
      title,
      date,
      numberLeft,
      buttonAvailable,
      tagImage,
      orderNumber,
      docAvailable,
      openDoc,
      subDocumentsList,
      doc,
      color,
      time,
    } = this.props;

    return (
      <div className={"activity-card-container"}>
        {
          this.getIcon(numberLeft, tagImage, color)
        }
        <title className={`activity-card-title ${color}`}>
          {mapActivityName(title, color)}
          {
            orderNumber && <span className="orderNumber">{orderNumber}</span>
          }
        </title>
        {
          statusContent ?
            <ul className="list">
              {
                statusContent.map(item =>
                  <li key={item}>{item}</li>
                )
              }
            </ul>
            :
            ""
        }
        {
          docAvailable && <div className="document-list">
            {
              subDocumentsList.map((docName, i) =>
                <Label key={i} as='a' basic onClick={e => {
                  openDoc({ doc, subDocumentsList })
                  e.stopPropagation()
                }} className="document-label">
                  {docName}
                </Label>)
            }
          </div>
        }
        {
          buttonAvailable || time ?
            <footer>
              {
                buttonAvailable &&
                <>
                  <Button>View File</Button>
                  <Button>Receipt</Button>
                </>
              }
              {
                time && <i className={color}>{convertEpochToDate(time, null, true)}</i>
              }
            </footer>
            : ""}
      </div>
    )
  }
}

export default ActivityCard
